<svelte:head>
  <title>Құпиялылық саясаты — Zetix</title>
  <meta name="description" content="Zetix платформасының құпиялылық саясаты. Деректерді өңдеу және сақтау ережелері." />
</svelte:head>

<article class="mx-auto max-w-3xl px-4 py-12 prose prose-slate">
  <h1>Құпиялылық саясаты</h1>
  <p><em>Соңғы жаңарту: 2026-04-21</em></p>

  <h2>1. Жалпы ережелер</h2>
  <p>
    Zetix платформасы (бұдан әрі — «Платформа») пайдаланушылардың жеке деректерін
    «Жеке деректер және оларды қорғау туралы» ҚР Заңына сәйкес өңдейді.
  </p>

  <h2>2. Жиналатын деректер</h2>
  <ul>
    <li>Есептік жазба: электрондық пошта, аты, сынып (таңдау бойынша)</li>
    <li>Қолдану статистикасы: көрген беттер, іздеу сұраулары (анонимді)</li>
    <li>Құрылғы деректері: шолғыш түрі, IP мекенжайы (қауіпсіздік үшін)</li>
  </ul>

  <h2>3. Деректерді қолдану мақсаты</h2>
  <ul>
    <li>Қызметті ұсыну және жеке бейімдеу</li>
    <li>Платформаны жақсарту</li>
    <li>Қауіпсіздікті қамтамасыз ету</li>
  </ul>

  <h2>4. Үшінші тұлғалармен бөлісу</h2>
  <p>
    Біз сіздің жеке деректеріңізді үшінші тұлғаларға сатпаймыз және бермейміз,
    тек заң талап еткен жағдайды қоспағанда.
  </p>

  <h2>5. Сіздің құқықтарыңыз</h2>
  <p>
    Сіз кез келген уақытта өз деректеріңізге қол жеткізуге, оларды өзгертуге
    немесе жоюды сұрауға құқылысыз. Бұл үшін
    <a href="mailto:privacy@zetix.kz">privacy@zetix.kz</a> мекенжайына хабарласыңыз.
  </p>
</article>
